module.exports = __webpack_public_path__ + "static/oppoLogo.7a0e5391.png";